import { buildUniqueIdName } from '~/helpers/seo-helpers';
var NavItemTree = () => import('./NavItemTree.vue');
var MdmLink = () => import( /* webpackChunkName: "link-desktop" */'~/components/atoms/MdmLink.vue');
export default {
  name: 'NavItemBranch',
  components: {
    NavItemTree,
    MdmLink
  },
  props: {
    level: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    withColor: {
      type: Boolean,
      default: false
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      buildUniqueIdName
    };
  },
  methods: {
    close() {
      if (this.isOpen) {
        this.isOpen = false;
        this.$refs.tree.close();
      }
    }
  }
};